module.exports = __webpack_public_path__ + "static/media/vibepure-1.c8151373.jpg";